<template>
  <el-form
    :model="formData"
    :rules="rules"
    ref="formData"
    label-position="left"
    label-width="0px"
    class="demo-ruleForm login-container"
  >
    <h3 class="title">管理登录</h3>
    <el-form-item prop="phone">
      <el-input type="text" v-model="formData.phone" auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input type="password" v-model="formData.password" auto-complete="off" placeholder="密码"></el-input>
    </el-form-item>
    <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit">登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        phone: "",
        password: ""
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      checked: true
    };
  },
  created: function() {
    document.title = "管理登录";
  },
  methods: {
    handleSubmit(ev) {
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.api.admin.user
            .login(Object.assign({}, this.formData))
            .then(response => {
              if (response.data.errorCode == 0) {
                this.$store.commit({
                  type: "loginIn",
                  name: response.data.data.name,
                  userName: response.data.data.phone,
                  id: response.data.data.id,
                  token: response.data.data.token
                });
                this.$router.replace({ path: "main" });
              }
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  height: 300px;
  width: 350px;
  padding: 15px;
  border-radius: 5px;
  background-clip: padding-box;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.title {
  margin: 10px auto 30px;
  text-align: center;
  color: #505458;
  font-size: 18px;
}

.remember {
  margin: 0px 0px 35px 0px;
}
</style>


// WEBPACK FOOTER //
// Login.vue?6bae86b9